'use strict';

var _ = require('lodash');
var window = require('./windowGlobal');
var stringifySpecialTypesReplacer = require('./stringifySpecialTypesReplacer');

var WIX_CODE_INTENT = 'WIX_CODE';
var WIX_CODE_CONSOLE_MESSAGE_TYPE = 'console';

function isPreview() {
    return window.parent && window.parent !== window;
}

function isWixCodeConsoleMessage(msg) {
    return msg.intent === WIX_CODE_INTENT && msg.type === WIX_CODE_CONSOLE_MESSAGE_TYPE;
}

function convertToWixCodeConsoleMessage(logLevel) {
    for (var _len = arguments.length, msg = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        msg[_key - 1] = arguments[_key];
    }

    return {
        intent: WIX_CODE_INTENT,
        type: WIX_CODE_CONSOLE_MESSAGE_TYPE,
        data: {
            logLevel: logLevel,
            args: [].concat(msg)
        }
    };
}

function sendMessage(wixCodeConsoleMessage) {
    window.parent.postMessage(serializeMessage(wixCodeConsoleMessage), '*');
}

function logWixCodeConsoleMessage(msg) {
    var logLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : logLevels.info;

    if (!msg) {
        return;
    }

    if (logLevel === logLevels.ERROR) {
        throw new Error('For error messages, please use "logWixCodeConsoleError"');
    }

    if (_.isString(msg)) {
        msg = convertToWixCodeConsoleMessage(logLevel, msg);
    }

    if (isWixCodeConsoleMessage(msg) && isPreview()) {
        sendMessage(msg);
    }
}

function serializeMessage(message) {
    return JSON.stringify(message, stringifySpecialTypesReplacer);
}

function logWixCodeConsoleError(error) {
    if (isPreview()) {
        var wixCodeConsoleMessage = convertToWixCodeConsoleMessage(logLevels.ERROR, error.name, error.message, error.stack);
        sendMessage(wixCodeConsoleMessage);
    }
}

var logLevels = {
    LOG: 'LOG',
    INFO: 'INFO',
    WARNING: 'WARNING',
    VERBOSE: 'VERBOSE',
    ERROR: 'ERROR'
};

module.exports = {
    logLevels: logLevels,
    logWixCodeConsoleMessage: logWixCodeConsoleMessage,
    logWixCodeConsoleError: logWixCodeConsoleError,
    serializeMessage: serializeMessage
};
//# sourceMappingURL=logWixCodeConsoleMessage.js.map